import { Language } from "../languages/labels/language.labels";

export function journalTypeList(lang: Language): {code: string, display: string}[] {
  return [
    { code: 'principal', display: lang.labels.principal },
    { code: 'sales', display: lang.labels.sales },
    { code: 'purchases', display: lang.labels.purchases },
    { code: 'human_resources', display: lang.labels.humanResources },
    { code: 'manually_created', display: lang.labels.manuallyCreated }
  ]
}

export function journalTypeValue(lang: Language, code: string): string {
  const labelByCode: Record<string, string> = {
    principal: lang.labels.principal,
    sales: lang.labels.sales,
    purchases: lang.labels.purchases,
    human_resources: lang.labels.humanResources,
    manually_created: lang.labels.manuallyCreated,
    closing: lang.labels.closingJournal,
  }
  return labelByCode[code] ?? lang.labels.undefined
}
